import { c as _c } from "react/compiler-runtime";
import { ArchiveTwoToneIcon } from "@components/common/icons";
import { EmptyPage } from "@src/components/common/empty-page/empty-page";
import { ProjectsDuoIcon, SearchDuoIcon } from "@flat-ui";
import { UtilsTypes } from "@stellar/utils";
/** Empty page content for projects overview */
export function ProjectsOverviewEmptyPage(t0) {
  const $ = _c(5);
  const {
    projectArchivingState,
    isSearching
  } = t0;
  if (isSearching) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyPage title="No results found" subtitle="There are no projects that match this search." icon={SearchDuoIcon} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (projectArchivingState === UtilsTypes.ProjectArchivingState.archived) {
    const t1 = `No ${projectArchivingState} projects`;
    let t2;
    if ($[1] !== t1) {
      t2 = <EmptyPage title={t1} subtitle="When you archive a project it will be stored here and remain in your workspace." icon={ArchiveTwoToneIcon} />;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t1 = `No ${projectArchivingState} projects`;
  let t2;
  if ($[3] !== t1) {
    t2 = <EmptyPage title={t1} subtitle="You don't have any active projects in your workspace. Create a new project or unarchive one of the projects in the archived tab." icon={ProjectsDuoIcon} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}